export function getFallbackStateShifts({ isLoading, allShifts, filteredShifts }) {
  if (isLoading) return { state: "loading" };

  if (!allShifts || allShifts.length === 0) {
    return { state: "noData" };
  }

  if (filteredShifts.length === 0) {
    return { state: "noMatch" };
  }

  return { state: "ok" };
}
